"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import Link from "next/link";
import { MessageSquare, UserPen } from "lucide-react";
import ArtistFollowButton from "../ArtistFollowButton";
import type { FollowState } from "../hooks/useFollowToggle";
import ArtistMessageDialog from "./ArtistMessageDialog";
type Props = {
  lang: "fa" | "en";
  isOwner: boolean;
  apiUsername: string;
  followState: FollowState;
  targetId: number;
  name: string;
};

/** Follow + message for a visitor, edit for the owner. */
export default function ArtistProfileActions(t0) {
  const $ = _c(22);
  const {
    lang,
    isOwner,
    apiUsername,
    followState,
    targetId,
    name
  } = t0;
  const isFa = lang === "fa";
  const [messageOpen, setMessageOpen] = useState(false);
  if (isOwner) {
    const t1 = `/${lang}/settings`;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <UserPen aria-hidden={true} />;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    const t3 = isFa ? "\u0648\u06CC\u0631\u0627\u06CC\u0634 \u067E\u0631\u0648\u0641\u0627\u06CC\u0644" : "Edit profile";
    let t4;
    if ($[1] !== t1 || $[2] !== t3) {
      t4 = <Link href={t1} className="v2-btn v2-btn--ghost v2-btn--lg v2-focus">{t2}{t3}</Link>;
      $[1] = t1;
      $[2] = t3;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    return t4;
  }
  let t1;
  if ($[4] !== apiUsername || $[5] !== followState || $[6] !== isFa) {
    t1 = <ArtistFollowButton username={apiUsername} initialState={followState} isFa={isFa} size="lg" />;
    $[4] = apiUsername;
    $[5] = followState;
    $[6] = isFa;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setMessageOpen(true);
    t3 = <MessageSquare aria-hidden={true} />;
    $[8] = t2;
    $[9] = t3;
  } else {
    t2 = $[8];
    t3 = $[9];
  }
  const t4 = isFa ? "\u0627\u0631\u0633\u0627\u0644 \u067E\u06CC\u0627\u0645" : "Message";
  let t5;
  if ($[10] !== t4) {
    t5 = <button type="button" className="v2-btn v2-btn--ghost v2-btn--lg v2-focus" onClick={t2}>{t3}{t4}</button>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setMessageOpen(false);
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== lang || $[14] !== messageOpen || $[15] !== name || $[16] !== targetId) {
    t7 = <ArtistMessageDialog open={messageOpen} onClose={t6} lang={lang} targetId={targetId} name={name} />;
    $[13] = lang;
    $[14] = messageOpen;
    $[15] = name;
    $[16] = targetId;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t1 || $[19] !== t5 || $[20] !== t7) {
    t8 = <>{t1}{t5}{t7}</>;
    $[18] = t1;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}